import React from 'react';
import RequestPage from '../RequestPage/RequestPage';
const CharterRequestPage = () => { 
    return (
        <div>
            <RequestPage isCharter={true} />
        </div>
    );
}
export default CharterRequestPage;